import React, {useCallback, useState} from 'react';
import {useParams} from 'react-router-dom';
import {
  CardContent,
  Grid,
  Button,
  Box,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  Checkbox,
  ListItemText,
  Stack,
} from '@mui/material';
import CompanyWithSchools from '../../../../../../components/onboarding/CompanyWithSchools';
import RetryPage from '../../../../../../components/styles/RetryButton';
import {IErrorResponse} from '../../../../../../dto/Html.dto';
import {
  getDeviceInstallationsApiPath,
  useRqListDeviceInstallations,
} from '../../../../../../react_query/device_installations/ListDeviceInstallations';
import {IDeviceInstallWithStations} from '../../../../../../dto/DeviceInstallation.dto';
import SubmitButton from '../../../../../../components/styles/buttons/SubmitButton';
import {useTaskContext} from '../../../../../task/TaskContext';
import {broadCastCloseTab} from '../../../../../../react_query/tasks/ListTasks';

const OnboardStationDownloads = () => {
  const [, setRetryTime] = React.useState(Date.now());
  const taskParam = useParams();
  const taskId = Number(taskParam.task_id);
  const {companyId} = useTaskContext();
  const [deviceIds, setDeviceIds] = useState<number[]>([]);

  const {data, isError, error} = useRqListDeviceInstallations(taskId);

  const handleSelection = useCallback((device_id: number) => {
    setDeviceIds(prev => {
      if (prev.includes(device_id)) {
        return prev.filter(id => id !== device_id);
      }
      return [...prev, device_id];
    });
  }, []);

  if (isError) {
    const errResp = error as IErrorResponse;
    return (
      <RetryPage
        pageTitle='List devices'
        errResp={errResp?.response}
        setRetryTime={setRetryTime}
        queryKey={[getDeviceInstallationsApiPath(taskId)]}
      />
    );
  }

  return (
    <Box className='m-2 blue-variant17 p-2'>
      <Box>
        <CardContent>
          <Grid container spacing={1}>
            <Grid item xs>
              <CompanyWithSchools company_id={companyId} />
            </Grid>
            <Grid item xs>
              <List>
                {data?.map((val: IDeviceInstallWithStations) => {
                  return (
                    <ListItem key={val.id} disablePadding>
                      <ListItemButton
                        onClick={() => handleSelection(val.id)}
                        dense>
                        <ListItemIcon>
                          <Checkbox
                            edge='start'
                            checked={deviceIds.includes(val.id)}
                            tabIndex={-1}
                            disableRipple
                          />
                        </ListItemIcon>
                        <ListItemText primary={val.station.name} />
                      </ListItemButton>
                    </ListItem>
                  );
                })}
              </List>
            </Grid>
          </Grid>
        </CardContent>
      </Box>
      <Stack
        direction='row'
        spacing={1}
        justifyContent='flex-end'
        className='my-3'>
        <Button variant='outlined' onClick={() => broadCastCloseTab()}>
          Cancel
        </Button>
        <SubmitButton
          payload={{
            deviceIds,
          }}
          url={`v1/task/${taskId}/device-downloads`}
          title='Submit'
          successAction={() => broadCastCloseTab()}
        />
      </Stack>
    </Box>
  );
};
export default OnboardStationDownloads;
